import React, { useState, useEffect } from 'react'
import { Box, useTheme } from '@mui/material'
import StarterKit from '@tiptap/starter-kit'
import BulletList from '@tiptap/extension-bullet-list'
import ListItem from '@tiptap/extension-list-item'
import OrderedList from '@tiptap/extension-ordered-list'
import CharacterCount from '@tiptap/extension-character-count'
import TextStyle from '@tiptap/extension-text-style'
import Color from '@tiptap/extension-color'
import Highlight from '@tiptap/extension-highlight'
import Placeholder from '@tiptap/extension-placeholder'
import './style.css'
import {
  MenuButtonBold,
  MenuButtonItalic,
  MenuControlsContainer,
  MenuDivider,
  MenuSelectHeading,
  MenuButtonBulletedList,
  MenuButtonOrderedList,
  RichTextEditor,
} from 'mui-tiptap'

const editorExtensions = [
  StarterKit.configure({
    bulletList: false,
    orderedList: false,
    listItem: false,
  }),
  BulletList,
  ListItem,
  OrderedList,
  TextStyle,
  Color,
  Highlight,
  Placeholder.configure({
    placeholder: 'Add details…',
    showOnlyWhenEditable: true,
    includeChildren: true,
  }),
  CharacterCount.configure({
    limit: 5000,
  }),
]

const RichTextField = ({ content, onContentChange, onBlur, minHeight = '100px', isEditMode = true }) => {
  const [characterCount, setCharacterCount] = useState(0)
  const theme = useTheme()
  useEffect(() => {
    onContentChange(content)
  }, [content, onContentChange])

  useEffect(() => {
    if (content === '') {
      setCharacterCount(0)
    }
  }, [content])
  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        textAlign: 'left',
        position: 'relative',
        '& .MuiCollapse-root': {
          backgroundColor: 'background.defaultdim',
          margin: 0,
          padding: 0,
        },
        '& .MuiMenuBar-root': {
          backgroundColor: 'background.defaultdim',
          margin: 0,
          padding: 0,
        },
        '& .MuiTiptap-FieldContainer-root': {
          backgroundColor: 'background.defaultdim',
        },
        '& .MenuSelectTextAlign-selectInput': {
          color: 'background.defaultdim',
        },
        '& .ProseMirror p.is-editor-empty:first-of-type::before, \
       & .ProseMirror .is-empty:first-of-type::before': {
          content: 'attr(data-placeholder)',
          color: 'text.secondary',
          fontSize: 14,
          pointerEvents: 'none',
          height: 0,
          float: 'left',
        },
      }}
    >
      <RichTextEditor
        className="rich-text full-width-toolbar"
        extensions={editorExtensions}
        content={content}
        editable={isEditMode ?? true}
        onUpdate={({ editor }) => {
          setCharacterCount(editor.storage.characterCount.characters())
          onContentChange(editor.getHTML())
        }}
        onBlur={onBlur}
        renderControls={() => {
          if (!isEditMode) return null // ✅ Hide toolbar when not in edit mode
          return (
            <MenuControlsContainer onClick={e => e.stopPropagation()}>
              <MenuSelectHeading />
              <MenuDivider />
              <MenuButtonBold />
              <MenuButtonItalic />
              <MenuDivider />
              <MenuButtonBulletedList />
              <MenuButtonOrderedList />
            </MenuControlsContainer>
          )
        }}
        editorProps={{
          attributes: {
            // style: minHeight
            //   ? `width: 100%; text-align: left; height: 100%; minHeight: ${minHeight}; transition: height 0.3s ease; background-color: ${
            //       bgcolor ?? ''
            //     }`
            //   : 'width: 100%; text-align: left; height: 100%; minHeight: 100px; transition: height 0.3s ease;', // Ensure the editor stretches fully across the container
            style: `height: ${minHeight}; overflow-y: auto; text-align: left; padding: 2px; color: ${theme.palette.text.primary}; transition: height 0.3s ease;`,
          },
        }}
      />
    </Box>
  )
}

export default RichTextField
